export default __webpack_public_path__ + "static/media/46-min.4f20392e.jpg";